function broadcast(componentName, eventName, params) {
    this.$children.forEach((child) => {
        const name = child.$options.componentName;
        if (name === componentName) {
            child.$emit(...[eventName].concat(params));
        } else {
            broadcast.apply(child, [componentName, eventName].concat([params]));
        }
    });
}

function order(componentName, methodName, params) {
    this.$children.forEach((child) => {
        const name = child.$options.componentName;
        if (name === componentName) {
            // child.$emit(...[eventName].concat(params));
            child[methodName].call(child, params);
        } else {
            order.apply(child, [componentName, methodName].concat([params]));
        }
    });
}
export default {
    methods: {
        dispatch(componentName, eventName, params) {
            let parent = this.$parent || this.$root;
            let name = parent.$options.componentName;

            while (parent && (!name || name !== componentName)) {
                if (parent.bubbleHook) {
                    parent.bubbleHook(eventName, params, this);
                }
                parent = parent.$parent;
                if (parent) {
                    name = parent.$options.componentName;
                }
            }
            if (parent) {
                parent.$emit(...[eventName].concat(params));
            }
        },
        broadcast(componentName, eventName, params) {
            broadcast.call(this, componentName, eventName, params);
        },
        order(componentName, methodName, params) {
            order.call(this, componentName, methodName, params);
        },
    },
};
